import React from 'react';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

import {PRINT_SCALING_OPTIONS, PRINT_ORIENTATION_OPTIONS, PRINT_PAGESIZE_OPTIONS } from '../../utils/constants/constants'
import PropTypes from 'prop-types';

const ProfileSettings = ({ orientation, setOrientation, scaling, setScaling,
                           pageSize, setPageSize, timezone, setTimezone, timezoneOptions, onSave, preferencesUnset }) => {

    const handleSave = () => {
    onSave();
  };

  return (
    <div style={{ flex: 1, minWidth: 0, height: 'calc(80vh - 50px)', padding: 24, border: '1px solid #eee', borderRadius: 8, background: '#fff' }}>
      <Typography variant="h5" component="h3" gutterBottom>User Preferences</Typography>
      {preferencesUnset && (
        <Typography variant="body2" style={{ color: '#d32f2f', marginBottom: 16 }}>
          Click on &quot;Save&quot; to set all preferences. Some options are not selected yet.
        </Typography>
      )}
      <div style={{ marginBottom: 20 }}>
        <Typography variant="subtitle1" gutterBottom>PDF Options</Typography>
        <FormControl fullWidth size="small" style={{ marginBottom: 12 }}>
          <InputLabel id="orientation-label">Orientation</InputLabel>
          <Select
            labelId="orientation-label"
            value={orientation}
            label="Orientation"
            onChange={e => setOrientation(e.target.value)}
          >
            {PRINT_ORIENTATION_OPTIONS.map(option => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth size="small" style={{ marginBottom: 12 }}>
          <InputLabel id="scaling-label">Scaling</InputLabel>
          <Select
            labelId="scaling-label"
            value={scaling}
            label="Scaling"
            onChange={e => setScaling(e.target.value)}
          >
            {PRINT_SCALING_OPTIONS.map(option => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth size="small" style={{ marginBottom: 12 }}>
          <InputLabel id="pagesize-label">Page Size</InputLabel>
          <Select
            labelId="pagesize-label"
            value={pageSize}
            label="Page Size"
            onChange={e => {setPageSize(e.target.value)}}
          >
            {PRINT_PAGESIZE_OPTIONS.map(option => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div>
        <Typography variant="subtitle1" gutterBottom>Preferred Time Zone</Typography>
        <FormControl fullWidth size="small">
          <InputLabel id="timezone-label">Time Zone</InputLabel>
          <Select
            labelId="timezone-label"
            value={timezone}
            label="Timezone"
            onChange={e => setTimezone(e.target.value)}
            MenuProps={{ style: { maxHeight: 300 } }}
          >
            {timezoneOptions.map(tz => (
              <MenuItem key={tz.code} value={tz.code}>{tz.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div style={{ flex: 1 }} />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
        <Button variant="contained" color="success" onClick={handleSave}>Save</Button>
      </div>
    </div>
  );
};

ProfileSettings.propTypes = {
  orientation: PropTypes.string.isRequired,
  setOrientation: PropTypes.func.isRequired,
  scaling: PropTypes.string.isRequired,
  setScaling: PropTypes.func.isRequired,
  pageSize: PropTypes.string.isRequired,
  setPageSize: PropTypes.func.isRequired,
  timezone: PropTypes.string.isRequired,
  setTimezone: PropTypes.func.isRequired,
  timezoneOptions: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onSave: PropTypes.func.isRequired,
  preferencesUnset: PropTypes.bool.isRequired,
};

export default ProfileSettings;
